type Title = {
  title: string;
};
type Label = {
  label: string;
};

const itemIsTitle = (item: unknown): item is Title => {
  if (item && typeof item === 'object' && 'title' in item) {
    return typeof item.title === 'string';
  }

  return false;
};
const itemIsLabel = (item: unknown): item is Label => {
  if (item && typeof item === 'object' && 'label' in item) {
    return typeof item.label === 'string';
  }

  return false;
};
const itemToStringDefault = <T>(item: T | null) => {
  if (typeof item === 'string' || typeof item === 'number') {
    return item.toString();
  }

  if (itemIsTitle(item)) {
    return item.title;
  }

  if (itemIsLabel(item)) {
    return item.label;
  }

  return '';
};

export {itemToStringDefault};
